import { useState, useEffect } from 'react'
import { useWeb3React } from '@web3-react/core'
import { Flex, FlexButton, NotificationDot, VvsTrophyIcon, HamburgerIcon, Drawer, useMatchBreakpoints } from 'vvs-uikit'
import styled from 'styled-components'
import useTheme from 'hooks/useTheme'
import { Link as RouterLink } from 'react-router-dom'
import { useConnectionError } from 'state/user/hooks'
import { formatUrlSearch } from 'utils/urlSearch'
import { Search } from 'config/constants/paths'

import MenuDrawerContent from './MenuDrawerContent'

const VvsGotchiRightSideMenuContent = () => {
  const { theme } = useTheme()
  const { isMobile } = useMatchBreakpoints()
  const web3 = useWeb3React()
  const { account } = web3
  const [open, setOpen] = useState(false)

  const [connectionError, setConnectionError] = useConnectionError()
  // web3 instance changes when the wallet is successfully connected again to the correct network.
  useEffect(() => {
    if (web3.active) {
      setConnectionError(null)
    }
  }, [web3, setConnectionError])

  return (
    <Flex gap="1rem">
      <StyledCircleLink
        key="Leaderboard"
        replace
        to={{ search: formatUrlSearch(Search.VVS_GOTCHI_LEADERBOARD) }}
        bg="#58BD95"
      >
        <VvsTrophyIcon width={24} height={24} />
      </StyledCircleLink>
      <NotificationDot show={!!connectionError || !account} dotProps={{ right: '-4px' }}>
        <FlexButton onClick={() => setOpen((o) => !o)}>
          <HamburgerIcon fill={isMobile ? 'white' : 'black'} width={34} height={34} />
        </FlexButton>
      </NotificationDot>
      <Drawer
        content={<MenuDrawerContent onClose={() => setOpen(false)} />}
        background={theme.colors.darkestNightBlue}
        setIsOpen={setOpen}
        isOpen={open}
        closeBtnBoxProps={{ top: '15px' }}
        closeIconProps={{ width: '32px', height: '32px' }}
      />
    </Flex>
  )
}

export default VvsGotchiRightSideMenuContent

const StyledCircleLink = styled(RouterLink)<{ bg?: string }>`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.mediaQueries.sm} {
    border: 2px solid black;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    justify-content: center;
    align-items: center;
    background: ${({ bg }) => bg ?? 'none'};
  }
`
